import viewerExport from '../component/report/reviewer/report'
import firstTimeExport from '../component/report/firsttime/report'
import holdExport from '../component/report/hold/report'
import expiredExport from '../component/report/expired/report'
import closedExport from '../component/report/closed/report'
import useTranslate from '../i18n/useTranslate'

const TestExport = () => {
    const translate = useTranslate()

    const exportViewerExcel = () => {
        // viewerExport({
        //     header: {
        //         projectType: 'ขอแก้ไขโครงการ',
        //         startDate: '3 กันยายน 2563',
        //         endDate: '3 กันยายน 2563',
        //         keyword: '-',
        //     },
        //     content: [
        //         {
        //             projectID: '1011',
        //             researcherName: 'ดร.กิตติคุณ เอกเอี่ยมพันธ์',
        //             considerType: 'Fullboard',
        //             projectName: 'ล่าท้าผี',
        //             committee1: 'ศาสตราจารย์.พญ.รุจิภา บุญจุบัน',
        //             committee2: 'ศาสตราจารย์ปวริศ โกวิทวีธรรม',
        //             committee3: 'ศาสตราจารย์ศุภกร อังอำนวยศิริ',
        //             committee: [],
        //         },
        //         {
        //             projectID: '1012',
        //             researcherName: 'ดร.บุลากร แสงสันเทียะ',
        //             considerType: 'Fullboard',
        //             projectName: 'ล่าท้าผี ภาค 2',
        //             committee1: 'ศาสตราจารย์.พญ.รุจิภา บุญจุบัน',
        //             committee2: 'ศาสตราจารย์ปวริศ โกวิทวีธรรม',
        //             committee3: 'ศาสตราจารย์ศุภกร อังอำนวยศิริ',
        //             committee: [],
        //         },
        //         {
        //             projectID: '1011',
        //             researcherName: 'ดร.มัลลิกา โสภา',
        //             considerType: 'Fullboard',
        //             projectName: 'ล่าท้าผี ภาค 3',
        //             committee1: 'ศาสตราจารย์.พญ.รุจิภา บุญจุบัน',
        //             committee2: 'ศาสตราจารย์ปวริศ โกวิทวีธรรม',
        //             committee3: 'ศาสตราจารย์ศุภกร อังอำนวยศิริ',
        //             committee: [],
        //         },
        //     ],
        //     translate: (value: string) => translate.get(value),
        // })
    }

    // const exportFirstTImeExcel = () => {
    //     firstTimeExport({
    //         header: {
    //             projectType: 'ขอแก้ไขโครงการ',
    //             startDate: '3 กันยายน 2563',
    //             endDate: '3 กันยายน 2563',
    //             keyword: '-',
    //             projectStatus: '-',
    //             faculty: '-',
    //         },
    //         content: [
    //             {
    //                 projectID: '1011',
    //                 receiveDate: '3 กันยายน 2563',
    //                 projectType: 'Fullboard',
    //                 projectStatus: 'Minor',
    //                 researcherName: 'ดร.กิตติคุณ เอกเอี่ยมพันธ์',
    //                 position: 'อาจารย์',
    //                 faculty: 'จิตวิทยา',
    //                 projectName: 'ล่าท้าผี',
    //             },
    //             {
    //                 projectID: '1012',
    //                 receiveDate: '3 กันยายน 2563',
    //                 projectType: 'Fullboard',
    //                 projectStatus: 'Minor',
    //                 researcherName: 'ดร.บุลากร แสงสันเทียะ',
    //                 position: 'อาจารย์',
    //                 faculty: 'จิตวิทยา',
    //                 projectName: 'ล่าท้าผี ภาค 2',
    //             },
    //             {
    //                 projectID: '1013',
    //                 receiveDate: '3 กันยายน 2563',
    //                 projectType: 'Fullboard',
    //                 projectStatus: 'Minor',
    //                 researcherName: 'ดร.มัลลิกา โสภา',
    //                 position: 'อาจารย์',
    //                 faculty: 'จิตวิทยา',
    //                 projectName: 'ล่าท้าผี ภาค 3',
    //             },
    //         ],
    //         translate: (value: string) => translate.get(value),
    //     })
    // }

    // const exportHoleExcel = () => {
    //     holdExport({
    //         header: {
    //             projectType: '-',
    //             startDate: '3 กันยายน 2563',
    //             endDate: '3 กันยายน 2563',
    //             keyword: '-',
    //         },
    //         content: [
    //             {
    //                 projectID: '1011',
    //                 receiveDate: '3 กันยายน 2563',
    //                 projectType: 'Fullboard',
    //                 educationLevel: 'ปริญญาเอก',
    //                 researcherName: 'ดร.กิตติคุณ เอกเอี่ยมพันธ์',
    //                 position: 'อาจารย์',
    //                 faculty: 'จิตวิทยา',
    //                 projectName: 'ล่าท้าผี',
    //             },
    //             {
    //                 projectID: '1012',
    //                 receiveDate: '3 กันยายน 2563',
    //                 projectType: 'Fullboard',
    //                 educationLevel: 'ปริญญาเอก',
    //                 researcherName: 'ดร.บุลากร แสงสันเทียะ',
    //                 position: 'อาจารย์',
    //                 faculty: 'จิตวิทยา',
    //                 projectName: 'ล่าท้าผี ภาค 2',
    //             },
    //             {
    //                 projectID: '1013',
    //                 receiveDate: '3 กันยายน 2563',
    //                 projectType: 'Fullboard',
    //                 educationLevel: 'ปริญญาเอก',
    //                 researcherName: 'ดร.มัลลิกา โสภา',
    //                 position: 'อาจารย์',
    //                 faculty: 'จิตวิทยา',
    //                 projectName: 'ล่าท้าผี ภาค 3',
    //             },
    //         ],
    //         translate: (value: string) => translate.get(value),
    //     })
    // }

    // const exportExpiredExcel = () => {
    //     expiredExport({
    //         header: {
    //             projectType: '-',
    //             startDate: '3 กันยายน 2563',
    //             endDate: '3 กันยายน 2563',
    //             keyword: '-',
    //         },
    //         content: [
    //             {
    //                 projectID: '1011',
    //                 endDate: '3 กันยายน 2563',
    //                 projectType: 'Fullboard',
    //                 researcherName: 'ดร.กิตติคุณ เอกเอี่ยมพันธ์',
    //                 position: 'อาจารย์',
    //                 projectName: 'ล่าท้าผี',
    //             },
    //             {
    //                 projectID: '1012',
    //                 endDate: '3 กันยายน 2563',
    //                 projectType: 'Fullboard',
    //                 researcherName: 'ดร.บุลากร แสงสันเทียะ',
    //                 position: 'อาจารย์',
    //                 projectName: 'ล่าท้าผี ภาค 2',
    //             },
    //             {
    //                 projectID: '1013',
    //                 endDate: '3 กันยายน 2563',
    //                 projectType: 'Fullboard',
    //                 researcherName: 'ดร.มัลลิกา โสภา',
    //                 position: 'อาจารย์',
    //                 projectName: 'ล่าท้าผี ภาค 3',
    //             },
    //         ],
    //         translate: (value: string) => translate.get(value),
    //     })
    // }

    // const exportClosedExcel = () => {
    //     closedExport({
    //         header: {
    //             projectType: '-',
    //             startDate: '3 กันยายน 2563',
    //             endDate: '3 กันยายน 2563',
    //             keyword: '-',
    //         },
    //         content: [
    //             {
    //                 projectID: '1011',
    //                 endDate: '3 กันยายน 2563',
    //                 projectType: 'Fullboard',
    //                 researcherName: 'ดร.กิตติคุณ เอกเอี่ยมพันธ์',
    //                 position: 'อาจารย์',
    //                 projectName: 'ล่าท้าผี',
    //             },
    //             {
    //                 projectID: '1012',
    //                 endDate: '3 กันยายน 2563',
    //                 projectType: 'Fullboard',
    //                 researcherName: 'ดร.บุลากร แสงสันเทียะ',
    //                 position: 'อาจารย์',
    //                 projectName: 'ล่าท้าผี ภาค 2',
    //             },
    //             {
    //                 projectID: '1013',
    //                 endDate: '3 กันยายน 2563',
    //                 projectType: 'Fullboard',
    //                 researcherName: 'ดร.มัลลิกา โสภา',
    //                 position: 'อาจารย์',
    //                 projectName: 'ล่าท้าผี ภาค 3',
    //             },
    //         ],
    //         translate: (value: string) => translate.get(value),
    //     })
    // }

    return (
        <div>
            <button onClick={exportViewerExcel}>ExportExel Viewer</button>
            {/* <button onClick={exportFirstTImeExcel}>ExportExel FirstTime</button> */}
            {/* <button onClick={exportHoleExcel}>ExportExel Hold</button> */}
            {/* <button onClick={exportExpiredExcel}>ExportExel Expired</button> */}
            {/* <button onClick={exportClosedExcel}>ExportExel Closed</button> */}
        </div>
    )
}

export default TestExport
